import { IBaseEntity, INode } from './base';
import { IImage, IImageDAO } from './image';
import { IModuleDAO } from './module';
import { ITagJoin } from './tag';
import { IText } from './text';
import { IOrgUserVariableDAO } from './user';

export interface IVariable extends IBaseEntity {
  name: string;
  type: VariableType;
  textId: number;
  moduleId: number;
}

export interface IVariableDAO extends IVariable {
  text: IText;
  image: IImageDAO;
  tags: ITagJoin[];
  options: IVariableOption[];
  module: IModuleDAO;
}

export interface IVariableReport extends IVariableDAO {
  organisationUserVariables: IOrgUserVariableDAO[]
  total?: number;
  totalScore?: number;
  totalPass?: number;
}

export enum VariableType {
  BOOLEAN = 0,
  SCORE = 1,
  OPTIONS = 2,
  ATTRIBUTE = 3
}

export enum VariableInstanceType {
  SET = 0,
  ADD = 1,
  MINUS = 2,
}

export interface IVariableOption extends IBaseEntity {
 
  variableId: number;
  name: string;
  value: number;
  total: number;
}

export interface IOverride extends IBaseEntity {
  variableId: number;
  orgUserId: number;
  groupId: number;
  value: number;
}

export enum VariableHandles {
  PASS = 'pass',
  FAIL = 'fail',
  SCORE = 'score',
  OPTION = 'option',
}
